import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, SprayCanIcon, MapPinnedIcon, HeartIcon, ClipboardCheckIcon } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: BookOpenIcon,
    title: 'Guía Paso a Paso',
    description: 'El Plan Maestro de 72 horas para detener el marcaje'
  }, {
    icon: SprayCanIcon,
    title: 'Protocolo de Limpieza Invisible',
    description: 'La fórmula exacta para borrar el rastro de orina para siempre'
  }, {
    icon: MapPinnedIcon,
    title: 'Mapa de Ubicación N+1',
    description: 'Dónde poner las cajas para que no haya fallas'
  }, {
    icon: HeartIcon,
    title: 'Hack de Feromonas Casero',
    description: 'Cómo usar el "olor de paz" de tu gato a tu favor'
  }, {
    icon: ClipboardCheckIcon,
    title: 'Checklist de Auditoría de Hogar',
    description: 'Identificá los disparadores de estrés en 5 minutos'
  }];
  return <section className="w-full bg-[#FAFAF7] py-16 md:py-20 px-6" data-id="element-95">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-5xl mx-auto" data-id="element-96">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1C1C1C] mb-12 text-center" data-id="element-97">
          Qué incluye el protocolo
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-98">
          {deliverables.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow" data-id="element-99">
                <Icon className="w-10 h-10 text-[#2D8C5A] mb-4" data-id="element-100" />
                <h3 className="font-['Playfair_Display'] text-xl font-semibold text-[#1C1C1C] mb-2" data-id="element-101">
                  {item.title}
                </h3>
                <p className="text-[#1C1C1C]/70 leading-relaxed" data-id="element-102">
                  {item.description}
                </p>
              </motion.div>;
        })}
        </div>
      </motion.div>
    </section>;
}